import { makeObservable } from "mobx";
import { IRackItem3 } from "./types";

const createDragAndDropStore = () => {
  const self = {
    onDragStart(index: number, rackID: number, item: IRackItem3) {
      window.DRAGING_FOR_MERGE = {
        index,
        rackId: ""+rackID,
        rackItem: {...item, user_id: ""+item.user_id},
      };
    },
    onDragFinish() {
      const t = setTimeout(() => (window.DRAGING_FOR_MERGE = undefined), 200);
      return () => clearTimeout(t);
    },
  }

  return makeObservable(self, {});
};

const dndStore = createDragAndDropStore();

export default dndStore;